import classNames from "classnames";
import { MediaQueryKind, useWorkspaceMediaQuery } from "client/Hooks";
import { setTrackingId } from "client/Misc/utils";
import { ReactElement, PropsWithChildren } from "react";
import { DropOverProps, DropOver } from "../DropOver/DropOver";
import { ResponsiveMenu } from "../ResponsiveMenu/ResponsiveMenu";
import styles from "./DropOverMenu.module.less";

export type DropOverMenuProps = DropOverProps & {
	hasWidthConstrained?: boolean;
	hasNoPadding?: boolean;
	title: string;
	trackingId: string;
};

export const DropOverMenu = (props: PropsWithChildren<DropOverMenuProps>): ReactElement => {
	const {
		hasWidthConstrained = false,
		hasNoPadding = false,
		hasResponsiveDropOver = true,
		title,
		trackingId,
		children,
		...restOfTheProps
	} = props;

	const isResponsive: boolean = useWorkspaceMediaQuery(MediaQueryKind.Responsive);

	return (
		<DropOver
			{...restOfTheProps}
			hasResponsiveDropOver={hasResponsiveDropOver}
		>
			{(hasResponsiveDropOver && isResponsive)
				? (
					<ResponsiveMenu
						trackingId={trackingId}
						onClose={restOfTheProps.onClose}
					>
						<ResponsiveMenu.Header title={title} />

						<ResponsiveMenu.Body>
							{children}
						</ResponsiveMenu.Body>
					</ResponsiveMenu>
				)
				: (
					<div
						{...setTrackingId(trackingId)}
						className={classNames(
							styles.root,
							{
								[styles.root_widthConstrained]: hasWidthConstrained,
								[styles.root_noPadding]: hasNoPadding
							}
						)}
					>
						{children}
					</div>
				)
			}

		</DropOver>
	);
};
DropOverMenu.displayName = "DropOverMenu";

const DropOverMenuDivider = (): ReactElement => {
	return (
		<div className={styles.divider} />
	);
};
DropOverMenuDivider.displayName = "DropOverMenuDivider";

DropOverMenu.Divider = DropOverMenuDivider;
